import { createStore } from 'redux'
import mainReducer from 'redux/Reducers/mainReducer'

const initialState = {}

const store = createStore(
  mainReducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() /*Para el debug en Chrome*/
)
export default store



// WEBPACK FOOTER //
// ./src/redux/redux.js